import { defineComponent } from 'vue'
import { store } from '#stores/oneform'
import SignaturePadVue from '../SignaturePad/SignaturePad.vue'

export default defineComponent({
  components: {
    SignaturePad: SignaturePadVue
  },
  data() {
    const form = store.financialPolicyForm

    const sections = {
      insurance: {},
      demographicInfo: {},
      communication: {},
      networkProviders: {},
      copays: {},
      nonCovered: {},
      additionalCharges: {},
      returnedChecks: {},
      selfPay: {},
        payments: {},
        refunds: {},
      cancellationNoShows: {},
      surgeryPolicy: {},
      outsideLab: {},
      diagnosticServices: {},
      diagnosisCoding: {}
    }

    return {
      form,
      sections
    }
  }
})
